var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FAQTab',{attrs:{"id":"faq-tab"},on:{"bevel-bar-clicked":function($event){return _vm.$store.dispatch('toggleROITray')}}},[_c('FontAwesome',{attrs:{"icon":"question-circle"}}),_vm._v("FAQ ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }